"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifyAuth = exports.validateResetPasswordToken = exports.resetPassword = exports.requestResetPasswordEmail = exports.register = exports.refreshAuth = exports.login = exports.getServerConfigs = void 0;
/* eslint-disable @typescript-eslint/no-unused-vars */
/* Package Imports */
var axios_1 = __importDefault(require("axios"));
var config_1 = require("@app/shared/config");
/* Authentication API methods - BEGIN */
// Retrieve configuration settings from the server
var getServerConfigs = function () { return __awaiter(void 0, void 0, void 0, function () {
    var url, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = config_1.Config.UI_SERVICES_URL + "/matomo";
                return [4 /*yield*/, axios_1.default.get(url)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data];
        }
    });
}); };
exports.getServerConfigs = getServerConfigs;
// Basic login using a user's credentials
var login = function (username, password, state) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios_1.default({
                    url: config_1.Config.UI_SERVICES_URL + "/login",
                    method: 'post',
                    auth: {
                        username: username,
                        password: password
                    },
                    data: { state: state }
                })];
            case 1:
                response = _a.sent();
                if (response.data && response.data.jwt) {
                    return [2 /*return*/, response.data.jwt];
                }
                else {
                    throw new Error('unable to authenticate');
                }
                return [2 /*return*/];
        }
    });
}); };
exports.login = login;
// Refresh the JWT token
var refreshAuth = function (token) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios_1.default({
                    url: config_1.Config.UI_SERVICES_URL + "/refresh-auth",
                    method: 'post',
                    data: { token: token }
                })];
            case 1:
                response = _a.sent();
                if (response.data) {
                    return [2 /*return*/, response.data];
                }
                else {
                    throw new Error('unable to re-authenticate');
                }
                return [2 /*return*/];
        }
    });
}); };
exports.refreshAuth = refreshAuth;
// Register a "new" user
var register = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios_1.default({
                    url: config_1.Config.UI_SERVICES_URL + "/users/register",
                    method: 'post',
                    data: params
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.register = register;
// Request a token to reset the password for the user, based on provided email address
var requestResetPasswordEmail = function (email) { return __awaiter(void 0, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = config_1.Config.UI_SERVICES_URL + "/users/password/reset/request";
                return [4 /*yield*/, axios_1.default.post(url, {}, {
                        params: {
                            email: email
                        }
                    })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.requestResetPasswordEmail = requestResetPasswordEmail;
// Reset the password for the user indicated in the token
var resetPassword = function (token, password, confirmPassword) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (password !== confirmPassword) {
                    throw new Error("Passwords don't match");
                }
                data = {
                    token: token,
                    newPassword: password
                };
                return [4 /*yield*/, axios_1.default({
                        url: config_1.Config.UI_SERVICES_URL + "/users/password/reset/submit",
                        method: 'post',
                        data: data
                    })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.resetPassword = resetPassword;
// Validates the reset password token is still active
var validateResetPasswordToken = function (token) { return __awaiter(void 0, void 0, void 0, function () {
    var url, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = config_1.Config.UI_SERVICES_URL + "/users/password/validate-token?token=" + token;
                return [4 /*yield*/, axios_1.default.post(url)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data];
        }
    });
}); };
exports.validateResetPasswordToken = validateResetPasswordToken;
// Verifies the JWT token is valid
var verifyAuth = function (token) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios_1.default({
                    url: config_1.Config.UI_SERVICES_URL + "/verify-auth",
                    method: 'post',
                    data: { token: token }
                })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data];
        }
    });
}); };
exports.verifyAuth = verifyAuth;
/* Authentication API methods - END */
